export default "__VITE_ASSET__BAgCac6z__"